import DaqProcessorModel from '../models/DaqProcessorModel';
import { observable } from 'mobx'
import BaseStore from './BaseStore';

class DaqProcessorStore extends BaseStore {

  daqLocationStore

  @observable protocolOptions = [
    { name: 'HTTP', id: 1 },
    // { name: 'TCP', id: 2 },
    { name: 'FTP', id: 3 },
    { name: 'File System', id: 4 },
    { name: 'MQTT', id: 5 },
    { name: 'Database (pg)', id: 6 },
    { name: 'RTDL Files', id: 7 },
    // { name: 'Hardware Network Server', id: 6 }
  ];

  constructor(transportLayer, daqLocationStore) {
    super(DaqProcessorModel, transportLayer);
    this.daqLocationStore = daqLocationStore;
  }

  findByDataSource(dataSourceId) {
    return this.items.filter(item => {
      return +item.data_source_id === +dataSourceId;
    });
  }
}

export default DaqProcessorStore;



// WEBPACK FOOTER //
// ./src/stores/DaqProcessorStore.js